import React from 'react';

const Suggestions = (props) => {
  const options = props.results.map((r, index) => (
      <li role="option" tabIndex="-1" 
      className="text-large  padding-left-tiny padding-horiz-micro pointer" 
      key={`typeresult_${index}`}>
        <a className="info_link" style={{textDecoration:"none"}} href={r.linkurl}>
          <span className="suggestion-wrapper">
           {r.linktext}
          </span>
        </a>
    </li>
  ));

  return (
    <div className="searchList search-autosuggest__suggestions-container" style={{border:"1px solid lightgray"}} >
    <ul role="listbox" tabIndex="-1" id="autosuggestId" className="search-top-results padding-bottom-zero border-bottom-none padding-vert-zero margin-vert-medium" style={{listStyleType: "none", margin: "0 !important"}}>{options}</ul>
    </div>
    )
};

export default Suggestions;


// WEBPACK FOOTER //
// ./src/components/modules/Suggestions.js